import { useContext } from "react";
import { dataa } from "../context/data";
import '../style/components/displayInvoice.css'

export default function DisplayInvoice (props) {
    const {setScene} = useContext(dataa);
    return (
        <div className="container-box show-container fixed flex flex-center-center">
            <button onClick={() => {
                    setScene([]); 
                    }} className='close'>x</button>
            <table>
                <thead>
                    <tr>
                        <th>id</th>
                        <th>الصنف</th>
                        <th>السعر</th>
                        <th>الكمية</th>
                        <th>الوزن</th>
                        <th>الخصم</th>
                        <th>الأجمالي</th>
                    </tr>
                </thead>
                <tbody>
                    {props.data.map((e,i) => 
                        <tr key={i}>
                            <td>{e.id}</td>
                            <td>{e.title}</td>
                            <td>{e.price.aftprice} EGP</td>
                            <td>{e.quantity}</td>
                            <td>{e.measure.value || "--"}</td>
                            <td>{e.discount.discountValue}</td>
                            <td>{e.total} EGP</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    )
}